import { useContext } from 'react';

import { ProfileContext } from '../../context/ProfileProvider';
import { TProfileContextProps } from '../../context/ProfileProvider/types';

const useProfile = () => {
  const context: TProfileContextProps = useContext(ProfileContext);
  return { ...context };
};

export default useProfile;
